document.addEventListener("DOMContentLoaded", () => {
    console.log("DOM fully loaded and parsed.");
    
    const swatches = document.querySelectorAll("[data-custom-option-value]");
    console.log("Swatches found:", swatches);

    // Event delegation at the document level
    document.addEventListener("click", (event) => {
        console.log("Click event detected:", event.target);
        
        const clickedSwatch = event.target.closest("[data-custom-option-value]");
        console.log("Clicked swatch:", clickedSwatch);
        if (!clickedSwatch) {
            console.log("No swatch clicked. Ignoring.");
            return; // Ignore clicks outside swatches
        }

        const parentLi = clickedSwatch.closest("li");
        console.log("Parent <li> element found:", parentLi);
        if (!parentLi) {
            console.error("No parent <li> found!");
            return;
        }

        const imageElement = parentLi.querySelector(".card__media .media img");
        console.log("Image element inside <li>:", imageElement);

        const imageElement2 = document.querySelectorAll(".product-card__image");
        console.log("Additional images (product-card__image):", imageElement2);

        if (!imageElement) {
            console.error("No image element found in parent <li>!");
            return;
        }

        const variantImage = clickedSwatch.getAttribute("data-attach-variant-image");
        console.log("Variant image URL:", variantImage);

        if (!variantImage) {
            console.error("No variant image URL found!");
            return;
        }

        // Precompute srcset once
        const srcset = `
            ${variantImage};width=165 165w,
            ${variantImage};width=360 360w,
            ${variantImage};width=533 533w,
            ${variantImage};width=720 720w,
            ${variantImage};width=940 940w,
            ${variantImage};width=1066 1066w,
            ${variantImage} 2688w
        `.trim();
        console.log("Generated srcset:", srcset);

        // Update the image src and srcset
        imageElement.src = variantImage;
        console.log("Updated main image src:", imageElement.src);

        // Update all additional images' src
        imageElement2.forEach(img => {
            img.src = variantImage;
            console.log("Updated additional image src:", img.src);
        });

        imageElement.srcset = srcset;
        console.log("Updated main image srcset:", imageElement.srcset);
    });
});
